/**
 * @generated SignedSource<<107b73f4e907e8679bcfab89ae19253f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "adverselyAffectedByPovertyOrInequality"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "allowedToBePcp"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "credentialingDelegated"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dateOfBirth"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ethnicityId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "firstName"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "genderId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lastName"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "livingInRuralAreas"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "middleInitial"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nameSuffix"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nickName"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "professionalDesignationId"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "qualification"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seeMinorities"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withDisabilities"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withDiverseGenderIdentities"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withDiverseSexualOrientations"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withLimitedEnglish"
},
v22 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "allowedToBePcp",
        "variableName": "allowedToBePcp"
      },
      {
        "kind": "Variable",
        "name": "credentialingDelegated",
        "variableName": "credentialingDelegated"
      },
      {
        "kind": "Variable",
        "name": "dateOfBirth",
        "variableName": "dateOfBirth"
      },
      {
        "kind": "Variable",
        "name": "effectiveFrom",
        "variableName": "effectiveFrom"
      },
      {
        "kind": "Variable",
        "name": "effectiveTo",
        "variableName": "effectiveTo"
      },
      {
        "kind": "Variable",
        "name": "ethnicityId",
        "variableName": "ethnicityId"
      },
      {
        "kind": "Variable",
        "name": "firstName",
        "variableName": "firstName"
      },
      {
        "kind": "Variable",
        "name": "genderId",
        "variableName": "genderId"
      },
      {
        "kind": "Variable",
        "name": "lastName",
        "variableName": "lastName"
      },
      {
        "kind": "Variable",
        "name": "middleInitial",
        "variableName": "middleInitial"
      },
      {
        "kind": "Variable",
        "name": "nameSuffix",
        "variableName": "nameSuffix"
      },
      {
        "kind": "Variable",
        "name": "nickname",
        "variableName": "nickName"
      },
      {
        "kind": "Variable",
        "name": "practitionerVersionId",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "professionalDesignationId",
        "variableName": "professionalDesignationId"
      },
      {
        "kind": "Variable",
        "name": "qualification",
        "variableName": "qualification"
      },
      {
        "kind": "Variable",
        "name": "willingToSeeMinorities",
        "variableName": "seeMinorities"
      },
      {
        "kind": "Variable",
        "name": "willingToSeePeopleAdverselyAffectedByPovertyOrInequality",
        "variableName": "adverselyAffectedByPovertyOrInequality"
      },
      {
        "kind": "Variable",
        "name": "willingToSeePeopleLivingInRuralAreas",
        "variableName": "livingInRuralAreas"
      },
      {
        "kind": "Variable",
        "name": "willingToSeePeopleWithDisabilities",
        "variableName": "withDisabilities"
      },
      {
        "kind": "Variable",
        "name": "willingToSeePeopleWithDiverseGenderIdentities",
        "variableName": "withDiverseGenderIdentities"
      },
      {
        "kind": "Variable",
        "name": "willingToSeePeopleWithDiverseSexualOrientations",
        "variableName": "withDiverseSexualOrientations"
      },
      {
        "kind": "Variable",
        "name": "willingToSeePeopleWithLimitedEnglish",
        "variableName": "withLimitedEnglish"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "PractitionerVersion",
  "kind": "LinkedField",
  "name": "applicableVersion",
  "plural": false,
  "selections": [
    (v23/*: any*/)
  ],
  "storageKey": null
},
v25 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  (v23/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditPractitionerVersionModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PractitionerMutationGroup",
        "kind": "LinkedField",
        "name": "practitioner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v22/*: any*/),
            "concreteType": "PractitionerVersionModifyPayload",
            "kind": "LinkedField",
            "name": "modifyVersion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerVersion",
                "kind": "LinkedField",
                "name": "practitionerVersion",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Practitioner",
                    "kind": "LinkedField",
                    "name": "practitioner",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PractitionerVersion",
                        "kind": "LinkedField",
                        "name": "versions",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "PractitionerVersions_Versions"
                          }
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v7/*: any*/),
      (v10/*: any*/),
      (v12/*: any*/),
      (v14/*: any*/),
      (v13/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v16/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v15/*: any*/),
      (v21/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v20/*: any*/),
      (v19/*: any*/),
      (v11/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditPractitionerVersionModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PractitionerMutationGroup",
        "kind": "LinkedField",
        "name": "practitioner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v22/*: any*/),
            "concreteType": "PractitionerVersionModifyPayload",
            "kind": "LinkedField",
            "name": "modifyVersion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerVersion",
                "kind": "LinkedField",
                "name": "practitionerVersion",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Practitioner",
                    "kind": "LinkedField",
                    "name": "practitioner",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PractitionerVersion",
                        "kind": "LinkedField",
                        "name": "versions",
                        "plural": true,
                        "selections": [
                          (v23/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "middleInitial",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "nickName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dateOfBirth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "nameSuffix",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "qualification",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "allowedToBePcp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "willingToSeePeopleWithLimitedEnglish",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "willingToSeeMinorities",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "willingToSeePeopleWithDisabilities",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "willingToSeePeopleWithDiverseGenderIdentities",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "willingToSeePeopleWithDiverseSexualOrientations",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "willingToSeePeopleLivingInRuralAreas",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "willingToSeePeopleAdverselyAffectedByPovertyOrInequality",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "credentialingDelegated",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveFrom",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveTo",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Gender",
                            "kind": "LinkedField",
                            "name": "gender",
                            "plural": false,
                            "selections": (v25/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Ethnicity",
                            "kind": "LinkedField",
                            "name": "ethnicity",
                            "plural": false,
                            "selections": (v25/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfessionalDesignation",
                            "kind": "LinkedField",
                            "name": "professionalDesignation",
                            "plural": false,
                            "selections": (v25/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/),
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e5afe3336bac2348490bb24070e76073",
    "id": null,
    "metadata": {},
    "name": "EditPractitionerVersionModalMutation",
    "operationKind": "mutation",
    "text": "mutation EditPractitionerVersionModalMutation(\n  $id: ID!\n  $firstName: String!\n  $lastName: String!\n  $middleInitial: String!\n  $nickName: String!\n  $nameSuffix: String!\n  $dateOfBirth: DateInput\n  $allowedToBePcp: Boolean\n  $qualification: String!\n  $genderId: StringInput\n  $ethnicityId: StringInput\n  $professionalDesignationId: StringInput\n  $withLimitedEnglish: YesNoUnknown\n  $seeMinorities: YesNoUnknown\n  $withDisabilities: YesNoUnknown\n  $withDiverseSexualOrientations: YesNoUnknown\n  $withDiverseGenderIdentities: YesNoUnknown\n  $livingInRuralAreas: YesNoUnknown\n  $adverselyAffectedByPovertyOrInequality: YesNoUnknown\n  $credentialingDelegated: Boolean!\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  practitioner {\n    modifyVersion(input: {practitionerVersionId: $id, firstName: $firstName, lastName: $lastName, middleInitial: $middleInitial, nameSuffix: $nameSuffix, nickname: $nickName, qualification: $qualification, dateOfBirth: $dateOfBirth, allowedToBePcp: $allowedToBePcp, genderId: $genderId, ethnicityId: $ethnicityId, professionalDesignationId: $professionalDesignationId, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo, willingToSeePeopleWithLimitedEnglish: $withLimitedEnglish, willingToSeeMinorities: $seeMinorities, willingToSeePeopleWithDisabilities: $withDisabilities, willingToSeePeopleWithDiverseSexualOrientations: $withDiverseSexualOrientations, willingToSeePeopleWithDiverseGenderIdentities: $withDiverseGenderIdentities, willingToSeePeopleLivingInRuralAreas: $livingInRuralAreas, willingToSeePeopleAdverselyAffectedByPovertyOrInequality: $adverselyAffectedByPovertyOrInequality, credentialingDelegated: $credentialingDelegated}) {\n      practitionerVersion {\n        id\n        practitioner {\n          versions {\n            ...PractitionerVersions_Versions\n            id\n          }\n          applicableVersion {\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment PractitionerVersions_Versions on PractitionerVersion {\n  id\n  firstName\n  lastName\n  middleInitial\n  nickName\n  dateOfBirth\n  nameSuffix\n  qualification\n  allowedToBePcp\n  willingToSeePeopleWithLimitedEnglish\n  willingToSeeMinorities\n  willingToSeePeopleWithDisabilities\n  willingToSeePeopleWithDiverseGenderIdentities\n  willingToSeePeopleWithDiverseSexualOrientations\n  willingToSeePeopleLivingInRuralAreas\n  willingToSeePeopleAdverselyAffectedByPovertyOrInequality\n  credentialingDelegated\n  effectiveFrom\n  effectiveTo\n  gender {\n    name\n    id\n  }\n  ethnicity {\n    name\n    id\n  }\n  professionalDesignation {\n    name\n    id\n  }\n}\n"
  }
};
})();

node.hash = "b9dd797bd838aa99ed4c1c985ae1da25";

export default node;
